import { type Job, type JobFilters, type JobSummary } from "@vidario/domain";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { useVidarioClient } from "../client";
import { queryKeys } from "../queryKeys";

export function useJobs(filters?: JobFilters): UseQueryResult<Job[]> {
  const client = useVidarioClient();
  return useQuery({
    queryKey: queryKeys.jobs(filters),
    queryFn: () => client.getJobs(filters),
  });
}

/** Every visible job with its candidate count + stepper progress, for the
 * Dashboard, which filters and pages the list itself (#13). */
export function useJobSummaries(): UseQueryResult<JobSummary[]> {
  const client = useVidarioClient();
  return useQuery({
    queryKey: queryKeys.jobsSummary(),
    queryFn: () => client.getJobsWithStats(),
  });
}

export function useJob(id: string): UseQueryResult<Job> {
  const client = useVidarioClient();
  return useQuery({
    queryKey: queryKeys.job(id),
    queryFn: () => client.getJob(id),
    enabled: Boolean(id),
  });
}
